import OptionsFormField from "vue-forms/components/OptionsFormField";

export default {
  mixins: [OptionsFormField],

  props: {
    dropdown: {
      default: true
    },

    options: {
      default: () => ["ADMIN", "BROKER", "PROVIDER", "CUSTOMER"]
    },

    item2option: {
      default() {
        return item => ({
          text: this.$t("userType." + item),
          value: item
        });
      }
    }
  }
};
